export enum FEATURE_FLAGS {
  foamAdvancedFilters = 'foam_advanced_filters',
  foamAgencySettingsManagerRoleCanRemoveCreator = 'foam_agency_settings_manager_role_can_remove_creator',
  foamAiBrandKeywords = 'ai_brand_keywords',
  foamCampaign = 'foam_rfp_gmail',
  foamChromePushNotifications = 'foam_chrome_push_notifications',
  foamCreatorListingPage = 'foam_creator_listing_page',
  foamCreatorProfile = 'foam_creator_profile',
  foamDemoContentSearchAutocomplete = 'foam_demo_content_search_autocomplete',
  foamContentSearchPostedAtColumn = 'foam_content_search_posted_at_column',
  foamEmailAssistant = 'foam_email_assistant',
  foamHeapDev = 'foam_heap_dev',
  foamMediaKitsNewSidebar = 'foam_media_kits_new_sidebar',
  foamNotificationSettings = 'foam_notification_settings',
  foamOffPlatform = 'foam_off_platform',
  foamProfileSettings = 'foam_profile_settings',
  foamReels = 'foam_reels',
  foamReelsMediaPack = 'foam_reels_media_pack',
  foamRosterHideFilters = 'foam_roster_hide_filters',
  foamRosterTalentSearch = 'foam_roster_talent_search',
  foamSavedListAgencies = 'foam_saved_lists_agencies',
  foamSavedLists = 'foam_saved_lists',
  foamSavedListsHighlightedContent = 'foam_saved_lists_highlighted_content',
  foamSavedListSave = 'foam_saved_list_save',
  foamStackedView = 'foam_stacked_view',
  foamTalentFilters = 'foam_talent_filters',
  foamOffPlatformAddSocials = 'foam_off_platform_add_socials',
  foamOffPlatformRemoveSocials = 'foam_off_platform_remove_socials',
  foamOffPlatformYoutube = 'foam_off_platform_youtube',
  foamSharedActivity = 'foam_shared_activity',
  foamMagicProfiles = 'foam_magic_profiles',
  snapchatAuth = 'foam_snapchat_authentication',
  foamSavedListsRoster = 'foam_saved_lists_roster',
  foamGlobalSearch = 'foam_global_search',
  foamOffPlatformRosterImport = 'foam_off_platform_roster_import',
  foamSavedListsPin = 'foam_saved_lists_pin',
  foamCollapsedView = 'foam_collapsed_view',
  foamEmbedsAlignment = 'foam_embeds_alignment',
  foamWebLinks = 'foam_web_links',
  foamUnverifiedToVerified = 'foam_unverified_to_verified',
  foamManagerContactShared = 'foam_manager_contact_shared',
  foamMediaPackContentLinksUpdate = 'foam_media_pack_content_links_update',
  foamTalentRecordAudienceDemo = 'foam_talent_record_audience_demo',
  foamAddTalent = 'foam_add_talent',
  foamSmartCreatorProfiles = 'foam_smart_creator_profiles',
  foamSmartProfilesBulkImport = 'foam_smart_profiles_bulk_import',
  foamSharedTalentProfile = 'foam_shared_talent_profile',
  foamTalentEmptyState = 'foam_talent_empty_state',
  foamTalentLocation = 'foam_talent_location',
  foamFeatureFlagController = 'foam_feature_flag_controller',
  foamContentProfileLink = 'foam_content_profile_link',
  foamContentSearchEmptyState = 'foam_content_search_empty_state',
  foamWeeklyReportToggle = 'foam_weekly_report_toggle',
  foamSavedListsEmptyState = 'foam_saved_lists_empty_state',
  foamTestingFlag = 'foam_testing_flag',
  foamCustomShareable = 'foam_custom_shareable',
  foamMarketingBanner = 'foam_marketing_banner',
  foamTalentRecordPersonalInfo = 'foam_talent_record_personal_info',
  foamTalentRecordChannelMetrics = 'foam_talent_record_channel_metrics',
  foamAgencySettingsBulkAssignPrimaryManager = 'foam_agency_settings_bulk_assign_primary_manager',
  foamMetricsCollaborations = 'foam_metrics_collaborations',
  foamProfileSharedPreviews = 'foam_profile_shared_previews',
  foamOnboardingNewManager = 'foam_onboarding_new_manager',
  foamNewFloatingActionBarInLists = 'foam_new_floating_action_bar_in_lists',
  foamNewFloatingActionBarInRoster = 'foam_new_floating_action_bar_in_roster',
  foamNewFloatingActionBarInAgencySettings = 'foam_new_floating_action_bar_in_agency_settings',
  foamAccessibleViewProfileBtn = 'foam_accessible_view_profile_btn',
  foamStreamingPoc = 'foam_streaming_poc',
  foamTalentGlobalFilters = 'foam_talent_global_filters',
  foamContentGlobalFilters = 'foam_content_global_filters',
  foamMediaKitsTextbox = 'foam_media_kits_textbox',
  foamMediaKitsVideo = 'foam_media_kits_video',
  foamMediaKitsContent = 'foam_media_kits_content',
  foamMediaKitsTalentFilter = 'foam_media_kits_talent_filter',
  foamMediaKitsStickyHeader = 'foam_media_kits_sticky_header',
  globalSearchSubNavbar = 'foam_global_search_sub_navbar',
  foamInviteOnPlatform = 'foam_invite_on_platform',
  foamInviteTalentFromAddFlow = 'foam_invite_talent_from_add_flow',
  foamAddOnPlatform = 'foam_add_on_platform',
  foamSmartTalentMetrics = 'foam_smart_talent_metrics',
  foamSnapchatAnalytics = 'foam_snapchat_analytics',
  foamMediaKitsTalentProfileTab = 'foam_media_kits__talent_profile_tab',
  foamDeprecateMediaPacks = 'foam_deprecate_media_packs',
  foamAddTalentFromList = 'foam_add_talent_from_list',
  foamListDetailEditName = 'foam_list_detail_edit_name',
  foamGlobalSearchInputDropdown = 'foam_global_search_input_dropdown',
  foamMediaKitsTheme = 'foam_media_kits_theme',
  foamMediaKitsMadeWithFoam = 'foam_media_kits_made_with_foam',
  foamMediaKitsShareToLinkedIn = 'foam_media_kits_share_to_linkedin',
  foamGlobalSearchQuickResults = 'foam_global_search_quick_results',
  foamMediaKitsStyleBtn = 'foam_media_kits_style_btn',
  foamGlobalSearchSuggestions = 'foam_global_search_suggestions',
  foamTalentTalkingAbout = 'foam_talent_talking_about',
  foamFontOverrideComicSans = 'foam_font_override_comic_sans',
  foamListPdf = 'foam_list_pdf',
  foamShareableWidget = 'foam_shareable_widget',
  foamRemoveMediaPacksAccess = 'foam_remove_media_packs_access',
  foamMediaKitsDefault = 'foam_media_kits_default',
  foamInviteSidebarUpdate = 'foam_invite_sidebar_update',
  foamAIBranding = 'foam_ai_branding',
  foamForceMaintenance = 'foam_force_maintenance',
  foamListDownloadCsv = 'foam_list_download_csv',
  foamListCustomOrder = 'foam_list_custom_order',
  foamSharedItemCtaOption = 'foam_shared_item_cta_option',
  foamPerformancePredictionMetrics = 'foam_performance_prediction_metrics',
  foamMentionCountRanges = 'foam_mention_count_ranges',
  foamPrimaryMediaKit = 'foam_primary_media_kit',
  foamSavedListNewTable = 'foam_saved_list_new_table',
  foamSavedListsStickyHeader = 'foam_saved_lists_sticky_header',
  foamTTAProcessingNotification = 'foam_tta_processing_notification',
  foamSharedListNewTable = 'foam_shared_list_new_table',
  foamMediaKitsBrandLogos = 'foam_media_kits_brand_logos',
  foamConversationStarterMentionedBrands = 'foam_conversation_starter_mentioned_brands',
  foamConversationStarterPrep1on1 = 'foam_conversation_starter_prepare_one_on_one',
  foamConversationStarterDraftEmailPitch = 'foam_conversation_starter_draft_email_pitch',
  foamContentDetailModalHooks = 'foam_content_detail_modal_hooks',
  foamTalentRecordOnboardingHooks = 'foam_talent_record_onboarding_hooks',
  foamCreatorMediaKits = 'foam_media_kits_for_creators',
  foamContentSearchMetrics = 'foam_content_search_metrics',
  foamContentSearchStickyHeader = 'foam_content_search_sticky_header',
  foamSharedListMessageTool = 'foam_shared_list_message_tool',
  foamTalentRecordGrowthRate = 'foam_talent_record_growth_rate',
  foamNewCreatorCard = 'foam_new_creator_card',
  foamMediaKitsOnboardingHooks = 'foam_media_kits_onboarding_hooks',
  foamAnalyzeContentOnboardingHook = 'foam_analyze_content_onboarding_hook',
  foamSearchBarOnboardingHooks = 'foam_search_bar_onboarding_hooks',
  foamSharedListStickyHeader = 'foam_shared_list_sticky_header',
  foamTalentFiltersStickyAppliedFilters = 'foam_talent_filters_sticky_applied_filters',
  foamContentSelection = 'foam_content_selection',
  foamRemoveMediaPacksAccessCreators = 'foam_remove_media_packs_access_creators',
  foamServiceUsageDashboard = 'foam_service_usage_dashboard',
  foamOutboundEmailGeneration = 'foam_outbound_email_generation',
  foamTrustedDomains = 'foam_trusted_domains',
  foamSharedListRolodex = 'foam_shared_list_rolodex',
  foamMediaKitsGrowthRateDesigns = 'foam_media_kits_growth_rate_designs',
  foamMetricsCards = 'foam_metrics_cards',
  foamModashAudienceDemographics = 'foam_modash_audience_demographics',
  foamMultiModalVideoUnderstanding = 'foam_multimodal_video_understanding',
  foamScouting = 'foam_scouting',
  foamDuplicateList = 'foam_duplicate_list',
  foamRequireEmailForSharedList = 'foam_require_email_for_shared_list',
  foamOverrideRequiredEmailForExceptions = 'foam_override_required_email_for_exceptions',
  foamTestData = 'foam_test_data',
  foamTryFluid = 'foam_try_fluid',
}
